import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Paper,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';

const PricingGrid = () => {
  const pricingData = [
    { service: 'Transport standard', prix: '50€', delai: '24-48h' },
    { service: 'Transport express', prix: '75€', delai: '12-24h' },
    { service: 'Transport urgent', prix: '100€', delai: '2-6h' },
    { service: 'Transport international', prix: 'Sur devis', delai: 'Variable' },
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography variant="h3" component="h1" gutterBottom align="center">
        Grille Tarifaire
      </Typography>
      <Typography variant="subtitle1" align="center" color="text.secondary" paragraph>
        Consultez nos tarifs pour différents services de transport
      </Typography>
      
      <TableContainer component={Paper} sx={{ mt: 4 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><Typography variant="h6">Service</Typography></TableCell>
              <TableCell align="right"><Typography variant="h6">Prix</Typography></TableCell>
              <TableCell align="right"><Typography variant="h6">Délai estimé</Typography></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pricingData.map((row) => (
              <TableRow key={row.service}>
                <TableCell component="th" scope="row">
                  <Typography>{row.service}</Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography>{row.prix}</Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography>{row.delai}</Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box sx={{ mt: 4 }}>
        <Typography variant="body1" color="text.secondary" paragraph>
          * Les prix indiqués sont donnés à titre indicatif et peuvent varier selon la distance et le volume.
        </Typography>
        <Typography variant="body1" color="text.secondary">
          * Pour des demandes spécifiques, n'hésitez pas à nous contacter pour un devis personnalisé.
        </Typography>
      </Box>
    </Container>
  );
};

export default PricingGrid;
